var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOtdocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 11.5,
    r: 10.75,
    stroke: "#42526D",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.758 14.049C8.296 14.049 7.87133 13.9417 7.484 13.727C7.10133 13.5123 6.79567 13.2137 6.567 12.831C6.343 12.4437 6.231 12.0097 6.231 11.529C6.231 11.0483 6.343 10.6167 6.567 10.234C6.79567 9.85133 7.10133 9.55267 7.484 9.338C7.87133 9.12333 8.296 9.016 8.758 9.016C9.22 9.016 9.64233 9.12333 10.025 9.338C10.4123 9.55267 10.7157 9.85133 10.935 10.234C11.159 10.6167 11.271 11.0483 11.271 11.529C11.271 12.0097 11.159 12.4437 10.935 12.831C10.711 13.2137 10.4077 13.5123 10.025 13.727C9.64233 13.9417 9.22 14.049 8.758 14.049ZM8.758 12.957C9.15 12.957 9.46267 12.8263 9.696 12.565C9.934 12.3037 10.053 11.9583 10.053 11.529C10.053 11.095 9.934 10.7497 9.696 10.493C9.46267 10.2317 9.15 10.101 8.758 10.101C8.36133 10.101 8.044 10.2293 7.806 10.486C7.57267 10.7427 7.456 11.0903 7.456 11.529C7.456 11.963 7.57267 12.3107 7.806 12.572C8.044 12.8287 8.36133 12.957 8.758 12.957ZM15.5419 9.086V10.045H14.2399V14H13.0429V10.045H11.7409V9.086H15.5419Z",
    fill: "#42526D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtdocument);
export default __webpack_public_path__ + "static/media/otdocument.9e13f2221eeb5c2be2c84364df50903b.svg";
export { ForwardRef as ReactComponent };